import { Address, erc20Abi } from 'viem';
import { useReadContract } from 'wagmi';

interface Options extends Omit<Parameters<typeof useReadContract>[0], 'abi' | 'address' | 'functionName' | 'args'> {
  address?: Address;
  token: Address;
  isEnabled?: boolean;
  scopeKey?: string;
  refetchInterval?: number;
}

export const useTokenBalance = ({
  address,
  token,
  isEnabled = true,
  scopeKey,
  refetchInterval = 1000 * 60,
  ...options
}: Options) => {
  return useReadContract({
    abi: erc20Abi,
    address: token,
    functionName: 'balanceOf',
    args: address ? [address] : undefined,
    scopeKey,
    query: { enabled: Boolean(isEnabled && address), refetchInterval },
    ...options,
  });
};
